<template>
  <div
    v-if="loaded"
    class="page"
  >
    <div class="page__sidebar">
      <side-bar
        :counters="predefinedFiltersSummary"
        @click-add-filter="onClickAddFilter"
        @update-option="onClickUpdateFilter($event)"
      />
    </div>
    <div class="page__main">
      <transition
        name="fade"
        mode="out-in"
      >
        <router-view
          ref="mainContent"
          :key="$route.path"
          class="page__main-content"
          @loadSummary="loadPredefinedFiltersSummary"
        />
      </transition>
    </div>
  </div>
</template>

<script>

import clinicalRequestService from '@/modules/clinicalModule/services/clinicalRequestService'
import sideBarStore from '@/modules/clinicalModule/components/SideBar/sideBarStore'
import SideBar from '@/modules/clinicalModule/components/SideBar/StudyRequestSideBar'
import customConfigResource from '@/api/resources/ui/CustomConfigResource'
import { requestState } from '@/api/resources/entityState/request-state'

export default {
    name: 'RequestsIndex',
    components: {
        SideBar
    },
    data() {
        return {
            loaded: false,
            sideBarState: sideBarStore.state,
            sidebarSummaryInterval: null,
            modalUiComponent: 'uicomponent.petitioner.modalconfig',
            predefinedFiltersSummary: { 'requestsWithReportNotReaded': '-', 'draftRequests': '-', 'requestsWithIssue': '-' }
        }
    },
    async created() {
        this.sidebarSummaryInterval = this.$_setSummaryInterval(this.loadPredefinedFiltersSummary)

        try {
            await Promise.all([
                this.loadPredefinedFiltersSummary(),
                this.loadModalConfiguration(),
                sideBarStore.loadCustomOptions(),
                sideBarStore.loadConfig(),
                requestState.loadStates()
            ])

            if (this.sideBarState.config.defaultOptionId) {
                sideBarStore.selectDefaultOption()
            } else if (this.$route.params.sidebarOption) {
                const option = sideBarStore.findOptionById(this.$route.params.sidebarOption)
                sideBarStore.setSelectedOption(option)
            }
        } finally {
            this.loaded = true
        }
    },
    beforeDestroy() {
        this.cleanSearchStateGlobalMixin()
        if (this.sidebarSummaryInterval !== null) {
            clearInterval(this.sidebarSummaryInterval)
        }
    },
    methods: {
        async loadModalConfiguration() {
            const customConfig = await customConfigResource.get(this.modalUiComponent)
            if (customConfig) {
                await this.$_setModalConfirmationState('clinicalModalsState', customConfig.config)
            }
        },
        async loadPredefinedFiltersSummary() {
            this.predefinedFiltersSummary = await clinicalRequestService.predefinedFiltersSummary()
        },
        onClickAddFilter() {
            if (this.$refs.mainContent.onSideBarClickAddFilter) {
                this.$refs.mainContent.onSideBarClickAddFilter()
            }
        },
        onClickUpdateFilter(option) {
            if (this.$refs.mainContent.onSideBarClickUpdateFilter) {
                this.$refs.mainContent.onSideBarClickUpdateFilter(option)
            }
        }
    }
}

</script>
